// extracted by mini-css-extract-plugin
export default {"root":"popupportal_root__VPQiL","center":"popupportal_center__mTLe-"};